import React, { useState } from 'react';
import { GeneralBox } from '../../Shared/GeneralBox';
import ParticlesBG from "../../Shared/ParticlesBG";

// Assets
import aiImage from '../../Assets/Images/AI.png';
import customImage from '../../Assets/Images/Custom.png';
import prebuiltImage from '../../Assets/Images/Prebuilt.png';

import OptionAI from './Socials/OptionAISocials';
import OptionPrebuilt from './Socials/OptionPrebuiltSocials';
import OptionCustom from './Socials/OptionCustomSocials';

export default function Socials() {
  const [selectedOption, setSelectedOption] = useState('');

  // Handle option selection
  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  // Helper function to render the correct option component based on selection
  function renderOptionComponent() {
    switch (selectedOption) {
      case 'ARTIFICIAL INTELLIGENCE': return <OptionAI />;
      case 'PREBUILT': return <OptionPrebuilt />;
      case 'CUSTOM': return <OptionCustom />;
      default: return null;
    }
  }

  return (
    <div id="socials-page">
      <section className="socials-header">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h1>
                <span className="color-font">SOCIAL MEDIA MANAGEMENT</span>
              </h1>
            </div>
          </div>

          <ParticlesBG />
          
          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>
      
      <section className="services">
        <div className="container">
          <div className="socials-intro">
            <p>
              Effective social media management is essential for modern business growth.
              <span className="highlight"> Brands with strategic social presence see up to 25% higher customer retention</span>,
              enabling stronger audience connections and brand loyalty.
            </p>
          </div>
          <h2><span className="color-font">Campaign Building Options</span></h2>
          <p className="options-subtitle">How do you want to shop for your Social Media Growth Plan?</p>
          
          {/* Options display using GeneralBox */}
          <div className="box-column-container">
            <div className="box-column" onClick={() => handleOptionSelect('ARTIFICIAL INTELLIGENCE')}>
              <GeneralBox
                title="ARTIFICIAL INTELLIGENCE"
                link="#"
                imageSrc={aiImage}
                description="AI-powered social media strategy tailored to your audience"
                className={`homepage-box ${selectedOption === 'ARTIFICIAL INTELLIGENCE' ? 'selected-box' : ''}`}
                useGlow={true}
              />
            </div>
            <div className="box-column" onClick={() => handleOptionSelect('PREBUILT')}>
              <GeneralBox
                title="PREBUILT"
                link="#"
                imageSrc={prebuiltImage}
                description="Ready-to-use social media plans for immediate implementation"
                className={`homepage-box ${selectedOption === 'PREBUILT' ? 'selected-box' : ''}`}
                useGlow={true}
              />
            </div>
            <div className="box-column" onClick={() => handleOptionSelect('CUSTOM')}>
              <GeneralBox
                title="CUSTOM"
                link="#"
                imageSrc={customImage}
                description="Personalized social media strategies designed for your specific goals"
                className={`homepage-box ${selectedOption === 'CUSTOM' ? 'selected-box' : ''}`}
                useGlow={true}
              />
            </div>
          </div>
          
          {/* Render the selected option component */}
          {selectedOption && (
            <div className="selected-option-container">
              {selectedOption === 'ARTIFICIAL INTELLIGENCE' && (
                <h2 className="selection-title">AI-Powered Social Media Strategy</h2>
              )}
              {selectedOption === 'CUSTOM' && (
                <>
                  <h2 className="selection-title">Platform Selection</h2>
                  {/* Platform options will go here */}
                </>
              )}
              {selectedOption === 'PREBUILT' && (
                <>
                  <h2 className="selection-title">Platform Selection</h2>
                  <p className="selection-subtitle">
                    If you want to build a Social Media Growth Plan for more than 1 platform, please select the Custom Builder or AI Builder
                  </p>
                  {/* Platform options will go here */}
                </>
              )}
              {renderOptionComponent()}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
